import React from 'react';

const AppBarNotificationIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0C10.5523 0 11 0.447716 11 1V3L10.9995 3.0317L10.9986 3.05341L10.9966 3.0824C13.836 3.55709 16 6.02583 16 9C16 12.0933 16.625 13.312 17.5987 15.2103L17.6333 15.2781C17.803 15.6088 17.5628 16 17.1909 16H2.80911C2.43728 16 2.19705 15.6088 2.36673 15.2781L2.4014 15.2103C3.37503 13.312 4.00003 12.0933 4.00003 9C4.00003 6.02583 6.16409 3.55709 9.00345 3.0824L9.00125 3.04284C9.00052 3.02863 9.00003 3.01435 9.00003 3V1C9.00003 0.447716 9.44778 0 10 0Z" fill="#5C5F62" />
    <path d="M12 18C12 19.1046 11.1045 20 10 20C8.89554 20 8.00003 19.1046 8.00003 18H12Z" fill="#5C5F62" />
  </svg>

);
export default AppBarNotificationIcon;
